import { ROLES } from "../../utils/constants";


export const OPS_ROLES = [
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
    ROLES.SUPPORT,
    ROLES.SUPER_SUPPORT,
    // The console's own tier roles. SUPPORT/SUPER_SUPPORT stay listed: they are untouched
    // and their existing users must keep working.
    ROLES.OPS_SUPPORT,
    ROLES.SUPER_OPS_SUPPORT,
];

export const PHARMACY_ROLES = [
    ROLES.PHARMACIST,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
    ROLES.SUPER_PHARMACIST,
];


// SUPPORT and SUPER_SUPPORT replaced the retired SALES / SUPER_SALES roles. Both tiers have
// identical access: each is in SCOPED_ROLES server-side (pillup-api
// classes/SalesOrders/scope.js), so each sees only the records whose salesOwnerId is
// their own -- on this console AND on the ops/legacy screens that share those endpoints.
export const SALES_ROLES = [
    ROLES.SUPPORT,
    ROLES.SUPER_SUPPORT,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
];


// The finance and logistics consoles ran on a PHARMACY_ROLES placeholder, left over from
// when their pages lived under /v2/pharmacy. That is why every pharmacist saw a Finance and
// a Logistics tab. These are the roles the API actually grants those screens to.
//
// Only the SUPER_ variants: pillup-api documents FINANCE, LOGISTICS and INVENTORY as
// reserved-and-unused -- they appear in no route allow-list, so a tab gated on them would
// open pages that 401 on every request.
export const FINANCE_ROLES = [
    ROLES.SUPER_FINANCE,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
];

export const LOGISTICS_ROLES = [
    ROLES.SUPER_LOGISTICS,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
];

// Inventory was the last console still living inside /v2/pharmacy. SUPER_INVENTORY had the
// API grants (shortages, purchase orders, strip size, catalogue, vendors) and no way to
// reach a single screen, because both pages were gated on PHARMACY_ROLES.
//
// PHARMACIST is listed: pillup-api's inventoryProcurement router grants PHARMACIST every
// route in the file, and pharmacists have been working procurement since it was built.
// Dropping them here would take a working screen away.
export const INVENTORY_ROLES = [
    ROLES.SUPER_INVENTORY,
    ROLES.PHARMACIST,
    ROLES.SUPER_PHARMACIST,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
];
